<ng-container *transloco="let t">

  <mat-label>{{label}}</mat-label>

  <mat-expansion-panel #panel [expanded]="false" togglePosition="before">
    <mat-expansion-panel-header class="py-4">
      <h3 class="py-2 mb-0 flex-fill">{{panelLabel || t('data-collector-edit.panelLabel')}}</h3>
      <button class="mat-elevation-z2 mr-2" mat-mini-fab color="accent" title="{{t('buttons.add')}}" type="button"
        [disabled]="localForm.invalid" (click)="addCfg(localForm.value)">
        <mat-icon>add</mat-icon>
      </button>
      <ng-content select="[topRightButtons]"></ng-content>
    </mat-expansion-panel-header>
    <ng-container #localFormEl="ngForm" [formGroup]="localForm" *ngIf="mode === 'edit'">
      <div class="row">
        <div class="col-6" *ngIf="!currentPlanId">
          <gt-enhanced-autocomplete #plan label="{{t('data-collector-edit.plan')}}" formControlName="plan"
            [searchFn]="planSearchFn" [labelFn]="planLabelFn" [valueMode]="'object'">
          </gt-enhanced-autocomplete>
        </div>
        <div class="col-6">
          <gt-enhanced-autocomplete #planStep label="{{t('data-collector-edit.planStep')}}" formControlName="planStep"
            [searchFn]="planStepSearchFn" [valueMode]="'object'">
          </gt-enhanced-autocomplete>
        </div>
        <div class="col-6">
          <gt-enhanced-autocomplete #procedureStep label="{{t('data-collector-edit.procedureStep')}}"
            formControlName="procedureStep" [searchFn]="procedureStepSearchFn" [valueMode]="'object'">
          </gt-enhanced-autocomplete>
        </div>
        <div class="col-6">
          <mat-form-field class="w-100" appearance="fill">
            <mat-label for="target">{{t('data-collector-edit.targets.label')}}</mat-label>
            <mat-select name="target" formControlName="target">
              <mat-option></mat-option>
              <mat-option *ngFor="let tgt of targets" [value]="tgt">{{t('data-collector-edit.targets.' + tgt)}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-6">
          <mat-form-field class="w-100" appearance="fill">
            <mat-label for="key">{{t('data-collector-edit.key')}}</mat-label>
            <input matInput name="key" formControlName="key" type="text" />
          </mat-form-field>
        </div>
      </div>
    </ng-container>
  </mat-expansion-panel>
  <ul>
    <li *ngFor="let cfg of configs$ | async; index as i">

      <span>{{getCfgLabel(cfg)}}</span>

      <mat-icon class="pointer" *ngIf="mode === 'edit'" title="{{t('buttons.delete')}}" (click)="removeCfg(i)"
        color="warn">delete
      </mat-icon>
    </li>
  </ul>
</ng-container>
